var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustrationReticule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_967_3765",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 104,
    height: 104
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_967_3765)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.6665 73.6663H82.3332V51.9997H73.6665V64.9997H60.6665V73.6663ZM21.6665 51.9997H30.3332V38.9997H43.3332V30.333H21.6665V51.9997ZM17.3332 86.6663C14.9498 86.6663 12.9096 85.8177 11.2123 84.1205C9.51512 82.4233 8.6665 80.383 8.6665 77.9997V25.9997C8.6665 23.6163 9.51512 21.5761 11.2123 19.8788C12.9096 18.1816 14.9498 17.333 17.3332 17.333H86.6665C89.0498 17.333 91.0901 18.1816 92.7873 19.8788C94.4846 21.5761 95.3332 23.6163 95.3332 25.9997V77.9997C95.3332 80.383 94.4846 82.4233 92.7873 84.1205C91.0901 85.8177 89.0498 86.6663 86.6665 86.6663H17.3332Z",
    fill: "#BEA885"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationReticule);
export default __webpack_public_path__ + "static/media/illustration-reticule.da01332f16c872dd820b307da1bb3634.svg";
export { ForwardRef as ReactComponent };